import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { de as deDateFnsLocale, enUS } from "date-fns/locale";
import { setDefaultOptions } from "date-fns";
import { merge } from "lodash";
import en from "@translations/en";
import de from "@translations/de";
import componentResources from "@translations/resources";
import { getStoredLanguage } from "./useStoredLanguage";

const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};

export const appNameMap: Record<string, string> = {
  finanzfluss: "Finanzfluss",
  rentablo: "Rentablo",
  depotcheck: "Depotcheck.ai",
};

const allResources = merge(componentResources, resources);
const supportEmailMap: Record<string, string> = {
  rentablo: "info@rentablo.de",
  depotcheck: "info@depotcheck.ai",
  finanzfluss: "copilot@finanzfluss.de",
  compliance: "info@wealthapi.eu",
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: allResources,
    fallbackLng: "en",
    lng: getStoredLanguage() || import.meta.env.VITE_APP_LANGUAGE || "de",
    interpolation: {
      skipOnVariables: false,
      escapeValue: false, // react already safes from xss
      defaultVariables: {
        appName: appNameMap[import.meta.env.VITE_APP_NAME || "rentablo"],
        supportEmail:
          supportEmailMap[import.meta.env.VITE_APP_NAME || "rentablo"] ||
          "info@rentablo.de",
      },
    },
    react: {
      bindI18nStore: "added",
    },
  });

const applyLanguageToEnvironment = (lng: string) => {
  const locale = lng.startsWith("de") ? deDateFnsLocale : enUS;
  setDefaultOptions({ locale });
  if (typeof document !== "undefined") {
    const appName = import.meta.env.VITE_APP_NAME || "rentablo";
    document.documentElement.lang = lng;
    document.title = i18n.t(`app.title.${appName}`);
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", document.title);
    }
  }
};

applyLanguageToEnvironment(i18n.language);
i18n.on("languageChanged", applyLanguageToEnvironment);

export default i18n;
